/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import Navigation from './lui-navigation'
import globalCssNavigation from 'lui-navigation.global.scss'
import NavigationDrawer from './lui-navigationdrawer'
import globalCssNavigationDrawer from 'lui-navigationdrawer.global.scss'

window.lui.registerComponent(Navigation, globalCssNavigation)
window.lui.registerComponent(NavigationDrawer, globalCssNavigationDrawer)



//////////////////
// WEBPACK FOOTER
// ./packages/lui-navigation/index.js
// module id = 252
// module chunks = 0 1 9